import React from 'react';
import './Contact.css'
import '../../root.css'
import SectionHeader from '../Common/SectionHeader';
import ContactInput from '../Common/ContactInput';
import MainBtn from '../Common/Btn';

const ContactForm = () => {
    return ( 
        <div className='Contact'>
            <SectionHeader SectionStyle="SectionHeader" SectionTitle="Get In" HighlightedWord="Touch" SectionP="Have questions about our properties? We'd love to hear from you. Send us a message and we'll respond as soon as possible."/>

            <form>
                <ContactInput InputType="text" InputPlaceholder="Full Name"/>
                <ContactInput InputType="email" InputPlaceholder="Email Address"/>
                <ContactInput InputType="text" InputPlaceholder="Phone Number"/>
                <ContactInput InputType="text" InputPlaceholder="Subject"/>
                <textarea placeholder='Message' name="" id=""></textarea>
                <MainBtn btnStyle="errorBtn" btnText="SEND MESSAGE" />
            </form>
        </div>
     );
}
 
export default ContactForm;